import { useState, useEffect } from 'react';
import useToken from 'hooks/useToken';

/**
 * Custom hook para obtener formas de pago desde el endpoint
 */
const useFormasPago = () => {
    const { token, setToken } = useToken();
    const [formasPago, setFormasPago] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const obtenerFormasPago = async () => {
            setLoading(true);
            setError(null);

            try {
                const response = await fetch("/api/orden/ObtenerFormasPago", {
                    method: 'GET',
                    headers: {
                        'Authorization': 'Bearer ' + token,
                        'Content-Type': 'application/json'
                    }
                });

                if (response.ok) {
                    const responseType = await response.json();
                    console.log("Formas de pago obtenidas:", responseType);
                    
                    if (responseType.iResponseType === 1) {
                        const formasPagoData = JSON.parse(responseType.detalles);
                        setFormasPago(formasPagoData.table2 || []);
                    } else {
                        setError(responseType.vMessage || 'No se encontraron formas de pago');
                    }
                } else {
                    if (response.status === 401) {
                        setToken(null);
                        location.href = "";
                    }
                    setError(`Error: ${response.status} ${response.statusText}`);
                }
            } catch (err) {
                setError(`Error al obtener formas de pago: ${err.message}`);
                console.error('Error al obtener formas de pago:', err);
            } finally {
                setLoading(false);
            }
        };

        if (token) {
            obtenerFormasPago();
        }
    }, [token]);

    return { formasPago, loading, error };
};

export default useFormasPago;
